const getYandexMetrikaId = () => {
  const value = process.env.VUE_APP_YM_ID;

  if (!/^\d+$/.test(value || "")) return null;

  const id = Number(value);

  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

const toAbsoluteUrl = path => new URL(path, window.location.origin).href;

const createYandexMetrikaQueue = () => {
  if (typeof window.ym === "function") return;

  const ym = function () {
    ym.a = ym.a || [];
    ym.a.push(arguments);
  };

  ym.l = Date.now();
  window.ym = ym;
};

const loadYandexMetrikaScript = id => {
  const src = `https://mc.yandex.ru/metrika/tag.js?id=${id}`;
  const isLoaded = Array.from(document.scripts).some(script => script.src === src);

  if (isLoaded) return;

  const script = document.createElement("script");
  const firstScript = document.getElementsByTagName("script")[0];

  script.async = true;
  script.src = src;
  firstScript.parentNode.insertBefore(script, firstScript);
};

export const initYandexMetrika = router => {
  const id = getYandexMetrikaId();

  if (!id) return;

  createYandexMetrikaQueue();
  loadYandexMetrikaScript(id);

  window.ym(id, "init", {
    accurateTrackBounce: true,
    clickmap: true,
    defer: true,
    ssr: true,
    trackLinks: true,
    webvisor: true,
  });

  let referer = document.referrer;

  router.afterEach(to => {
    const url = toAbsoluteUrl(to.fullPath);

    window.ym(id, "hit", url, {
      referer,
      title: document.title,
    });

    referer = url;
  });
};
